<template>
  <div class="wrong-app">
    <div class="wrong">
      <div class="user-title">
        <span>错题巩固</span>
      </div>

      <div class="wrong-list" v-if="wrongList && wrongList !== ''">
        <div
          class="list-box"
          v-for="(item, index) in wrongList"
          :key="index"
          :class="{ 'list-box-active': listBoxActive == index }"
        >
          <div class="list-tab-a-box">
            <div
              class="list-tab-a"
              @click="
                () => {
                  item.name == '随机练习'  && wrongList[index].data !== ''
                    ? openWrongAnswer('', 2, item.wgg)
                    : slideOpen(index);
                }
              "
            >
              <i></i>
              <p :class="{ listtabaactive: listtabaactive == index }">
                {{ item.name }}
              </p>
              <div style="margin-left: 20px; font-size: 12px"></div>
              <!-- <div style="margin-left: 20px;font-size: 12px;">错题数:<span style="font-weight: bold;color: #e60012">{{item.wgg}} </span></div> -->
            </div>
          </div>
        </div>
      </div>

      <div
        class="wrong-list"
        v-if="(wrongList && wrongList !== '') || listBoxActive == index"
      >
        <div
          class="list-box"
          v-for="(item, index) in wrongList"
          :key="index"
          :class="{ 'list-box-active': listBoxActive == index }"
        >
          <div class="list-tab-a-box">
            <!-- <div class="list-tab-a" @click="()=>{
							item.name == '随机练习'?openWrongAnswer('',2,item.wgg): slideOpen(index)
						}"> -->
            <!-- <i></i> -->
            <!-- <p>{{item.name}}</p> -->
            <!-- <div style="margin-left: 20px;font-size: 12px;"></div> -->
            <!-- <div style="margin-left: 20px;font-size: 12px;">错题数:<span style="font-weight: bold;color: #e60012">{{item.wgg}} </span></div> -->

            <!-- </div> -->
            <!-- <div class="circlechart" @click="openCircleAnswer(index)">
							<img v-if="item.ygg >0" src="/images/test_7_h.png" alt />
							<img v-else src="/images/test_7.png" alt />
							<el-progress
								type="circle"
								:percentage="item.ygg == 0 ? 0.1 : Number(item.ygg/item.wgg*100)"
								:width="30"
								:stroke-width="2"
								color="#e60012
								:show-text="false"
							></el-progress>
						</div>-->
          </div>
  
          
            <div
              class="list-tab-b-box"
              v-for="(v, ins) in wrongpage"
              :key="ins"
              @click="openWrongAnswer(v.id, v.type || 2, v.wgg)"
             
            >
           
              <div   v-if="v ==null?false:true "  class="list-tab-b">
                <p>{{ v.name }}</p>
                <div style="margin-left: 20px; font-size: 15px">
                  答错<span style="font-weight: bold; color: #e60012">{{
                    v.wgg
                  }}</span
                  >道
                </div>
                <div style="color: red">
                  <img style="width: 20px" src="/images/bi.png" alt="" />
                  开始答题
                </div>
              </div>
              <div v-else>
              
              </div>
              <!-- <div class="circlechart1">
									<img v-if="v.ygg >0" src="/images/test_7_h.png" alt />
									<img v-else src="/images/test_7.png" alt />
									<el-progress
										type="circle"
										:percentage="v.ygg == 0 ?0.1 : Number(v.ygg/v.wgg*100)"
										:width="30"
										:stroke-width="2"
										color="#e60012
										:show-text="false"
									></el-progress>
								</div>-->
            </div>
          </div>
        </div>
     
  
			<div class="pagein">
   


					<el-pagination 
           background
           @size-change="sezechange" 
            layout="prev, pager, next" 
            :total="count"
            @current-change="currentchange"
            :current-page.sync="currentPage"
            
            >

      		</el-pagination>
			</div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  inject: ["reload"],
  data() {
    return {
      wrongList: [],
      listBoxActive: 0,
      precentZero: 0.1,
      listtabaactive: 0,
			arrlength:[],
			sumber:0,
			count:0,
      wrongpage:[],
      active:0,
      currentPage:1,
    };
  },
  methods: {
    // 上下页
    sezechange(val){
     
    },
    // 点击跳转
    currentchange(val){
      console.log( this.arrlength[val-1])
    
     this.wrongpage = this.arrlength[val-1]
    },
    slideOpen(index) {
      this.listtabaactive = index;
      console.log(index)
      if (index == "随机练习") {
        this.$router.push({
          path: "/answerWrong",
          query: {
            mid: 2,
          },
        });
      } else {
        this.active = index
        
        this.getWrongTopicData(index,'ns')
        
      }
    },
    async getWrongTopicData(index,ns) {
      if(ns =='ns'){
         this.currentPage = 1
      }
      //console.log("用户错题")
      let userinfo = JSON.parse(localStorage.getItem("userInfo"));
      const { data: res } = await this.$api.getWrongExam({
        user_id: userinfo.id,
      });
      this.wrongList = res;
      for (let i of this.wrongList) {
        let num = 0;
        for (let j of i.data) {
          num += j.wgg;
          i.wgg = num;
					
        }
      }
		  this.sumber =  Math.ceil(this.wrongList[index].data.length/10)
			 this.count = this.wrongList[this.active].data.length
			let a =0
	 	 for(let ber = 0;ber<this.sumber;ber++){
					 	let b = []
			   for(let nen = 0;nen < 10;nen++){
					 	b[nen]   =   this.wrongList[index].data[a]
						 a++
				 }
				 this.arrlength[ber] = b
		}   
		 this.wrongpage = this.arrlength[0]

  
      //console.log(this.wrongList)

      // this.$loading();
      // var param = {};
      // this.$post("wrongTopic", param).then((res) => {
      // 	this.wrongList = res.data;
      // });
      // setTimeout(() => {
      // 	this.$loading().close();
      // }, 500);
    },
    // openCircleAnswer(index) {
    // 	var list = this.wrongList[index];
    // 	for (let i = 0; i < Object.keys(list).length - 2; i++) {
    // 		if (list[i].wgg > 0) {
    // 			var id = list[i].aid;
    // 		}
    // 		break;
    // 	}
    // 	this.$router.push({
    // 		path: "/answerWrong",
    // 		query: {
    // 			qid: id,
    // 		},
    // 	});
    // },
    openWrongAnswer(id, type, number) {
      this.$router.push({
        path: "/answerWrong",
        query: {
          sub_id: id,
          type: type,
          answer_number: number,
          state:200
        },
      });
    },
  },
  created() {
    this.getWrongTopicData(0);
		console.log( this.arrlength)
  },
};
</script>

<style scoped>
.wrong {
  padding: 0 40px;
  position: relative;
  height: 753px;
}

.wrong-list {
  /* border: 1px solid #ebebeb; */
  margin-top: 30px;
  padding: 0 15px;
  /* padding-bottom: 15px;
		border-radius: 10px; */
  display: flex;
  position: relative;
}

.wrong-list .list-box:last-child {
  border-bottom: none;
}
.list-tab-a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid #ebebeb;
}
.list-tab-a {
  border: none !important;
}
.list-tab-b {
  display: flex;
  width: 734px;
  justify-content: space-between;
  cursor: pointer;
}
.list-tab-b-box :hover {
  background-color: #f3efef;
  border-radius: 5px;
}
.list-tab-b p {
  width: 360px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-tab-a p {
  border: 1px solid red;
  border-radius: 5px;
  padding: 9px 20px;
  background-color: #f8eeee;
  color: red;
  opacity: 0.7;
  cursor: pointer;
}
.listtabaactive {
  background-color: red !important;
  color: white !important;
}

.list-box-active .contant {
  width: 100%;
  display: block;
  padding-left: 15px;
  color: #000;
}
.wrong-app .list-tab-a div,
.wrong-app .list-tab-b div {
  margin-right: 0;
}
.list-tab-b-box {
  width: 100% !important;
  transform: all 0.5 ease;
}
.list-tab-sj i {
  background: none;
  border: 1px solid #ccc;
  border-radius: 100%;
}
.pagein{
  width: 95%;
  
	text-align: center;
	margin-top: 20px;
  position: absolute;
    top: 689px;
   
}
</style>
